import React, { useState, useEffect, useContext } from "react";
import '../../css/trust.css';
import CustomerProfile from './customerProfile';
import CustomerBrand from './brand';
import MessagingService from './services';
import CreateCustomerProfile from "./create/createProfile";
import { fetchWithDefaults } from '../../config/fetchDefault';
import CreateCampaign from "./create/createCampaign";
import AddNumberToService from "./create/addNumbersToService";
import { useSelector } from 'react-redux';
import image from '../../assets/icons/loading-loader.gif';
import { AgentContext } from "../../context/AgentContext";


function TrustHub({ data }) {
    const agentInfo = useSelector((state) => state.agent.userData);
    const agentId = useSelector((state) => state.agent.userData).agentId;
    const formatString = (inputString) => {
        const parts = inputString.split('_');
        const formattedString = parts.map((part, index) => {
            return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
        });
        return formattedString.join(' ');
    };
    const [customerProfiles, setCustomerProfiles] = useState(data[0].twilio);
    const [profileInfo, setProfileInfo] = useState(data[0].hub)
    const [addCustProfile, setAddCustProfile] = useState(false)
    const [loading, setLoading] = useState(false)
    const [brandInfo, setBrandInfo] = useState([])
    const [serviceInfo, setServiceInfo] = useState([])
    const [compliant, setAsCompliant] = useState(false);
    const [profileType, setProfileType] = useState(false);
    const [newBrand, setNewBrand] = useState(false);
    const [newCampaign, setNewCampaign] = useState(false);
    const [newService, setNewService] = useState(false);
    const [numberChoice, setNumberChoice] = useState(false);
    const [update, setUpdate] = useState(false);


    const handleAddCustProfile = () => {
        setAddCustProfile(!addCustProfile)
    }
    const fetchBrand = async () => {
        try {
            setLoading(true)
            const response = await fetchWithDefaults(`/trustHub/brandLookup?agent=${agentInfo.agentId}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();
            setBrandInfo(jsonData)
            setLoading(false)
        } catch (error) {
            setLoading(false)
            console.error('Error fetching data:', error);
        }
    };
    const handleSubmitBrand = async (fields, brand, type) => {
        let service = false;
        if (newCampaign && newCampaign !== true) {
            service = newCampaign
        }

        try {
            setLoading(true)
            const requestOptions = {
                method: 'POST',
                body: JSON.stringify({
                    fields: fields,
                    brand: brand,
                    type: type,
                    service: service
                })
            };
            const response = await fetchWithDefaults(`/trustHub/submitCampaign?agent=${agentInfo.agentId}`, requestOptions);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();
            setNewService(true);
            setNewCampaign(false);
            setNumberChoice(jsonData);
            fetchServices();
            setLoading(false)
        } catch (error) {
            setLoading(false)
            console.error('Error fetching data:', error);
        }
    }
    const fetchServices = async () => {
        try {
            setLoading(true)
            const response = await fetchWithDefaults(`/trusthub/serviceLookup?agent=${agentInfo.agentId}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();
            setServiceInfo(jsonData)
            setLoading(false)
        } catch (error) {
            setLoading(false)
            console.error('Error fetching data:', error);
        }
    };
    const submitCustomerProfile = async (formData, type) => {
        try {
            setLoading(true);
            const requestOptions = {
                method: 'POST',
                body: JSON.stringify(formData)
            };

            const response = await fetchWithDefaults(`/trustHub/customerProfile?agent=${agentInfo.agentId}&type=${type}`, requestOptions);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            // const jsonData = await response.json();
            //setAddCustProfile(false);
            setLoading(false);
            window.location.reload();
        } catch (error) {
            setLoading(false);
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
        fetchBrand();
        fetchServices();
    }, [update])
    const {isB2B} = useContext(AgentContext)
    return (
        <div className={`${isB2B ? 'b2b ' : ''}outerWrapper`}>

            {loading && (
                <div className="loadingScreen">
                    <div className="loaderWrapper">
                        <img src={image} alt="Loading Gif" style={{ width: '100%' }} />
                    </div>
                </div>
            )}
            <span className="outerWrapperTitle">
                <span className="outerWrapperIcon">

                </span>
                TrustHub
            </span>
            {compliant && (
                <div className="compliantWrapper">
                    <div className="compliantHeader">
                        <div className="compliantTitle">You Are Compliant</div>
                    </div>
                    <div className="compliantContent">
                        You are all set and ready to message!!
                    </div>
                </div>
            )}
            <AgentContext.Provider value={{ isB2B }}>
                <div
                    className="mainBlockOuterWrapper"
                    style={{ justifyContent: "space-around" }}
                >
                    <CustomerProfile setLoading={setLoading} profileInfo={profileInfo} setProfileInfo={setProfileInfo} agentId={agentInfo.agentId} setAddCustProfile={setAddCustProfile} formatString={formatString} data={customerProfiles} soleSid={profileInfo[0].soleCustomer} einSid={profileInfo[0].hubCustomer} activePayment={profileInfo[0].activePayment} />
                    {customerProfiles.length > 0 && (
                        <CustomerBrand setNewBrand={setNewBrand} agentId={agentInfo.agentId} formatString={formatString} data={profileInfo} brandInfo={brandInfo} fetchBrand={fetchBrand} />
                    )}
                    {brandInfo.length > 0 && (
                        <MessagingService newService={newService} setNumberChoice={setNumberChoice} setNewCampaign={setNewCampaign} agentId={agentId} setAsCompliant={setAsCompliant} formatString={formatString} data={profileInfo} serviceInfo={serviceInfo} fetchServices={fetchServices} brandInfo={brandInfo} />
                    )}
                </div>
                {addCustProfile && (
                    <CreateCustomerProfile setUpdate={setUpdate} setAddCustProfile={setAddCustProfile} submitCustomerProfile={submitCustomerProfile} profileType={profileType} setProfileType={setProfileType} />
                )}
                {newBrand && (
                    <CreateCustomerProfile setUpdate={setUpdate} setAddCustProfile={setAddCustProfile} submitCustomerProfile={submitCustomerProfile} profileType={profileType} setProfileType={setProfileType} />
                )}
                {newCampaign && (
                    <CreateCampaign handleSubmitBrand={handleSubmitBrand} brandInfo={brandInfo} setNewCampaign={setNewCampaign} setAddCustProfile={setAddCustProfile} submitCustomerProfile={submitCustomerProfile} profileType={profileType} setProfileType={setProfileType} />
                )}
                {numberChoice && (
                    <AddNumberToService setLoading={setLoading} fetchServices={fetchServices} setUpdate={setUpdate} type={numberChoice.type} setNumberChoice={setNumberChoice} service={numberChoice.service} agent={agentId} brandInfo={brandInfo} serviceInfo={serviceInfo}/>
                )}
            </AgentContext.Provider>
        </div>
    );
}

export default TrustHub;
